import React, { useMemo } from 'react';

// * utils
import { createDirectoryTree } from '../utils/index.js';

// * components
import { MultiVirtualTreeSelect } from './MultiVirtualTreeSelect.js';

// * types
import type { MultiTreeSelectProps } from '../types/index.js';

export const MultiTreeSelect = ({ root, onChange, onSelect, options = {} }: MultiTreeSelectProps) => {
  const { ignore, rootAlias, previewColor, indicatorColor } = options;
  const tree = useMemo(() => createDirectoryTree(root, { rootAlias, ignore }), [root]);

  return (
    <MultiVirtualTreeSelect
      tree={tree}
      onChange={onChange}
      onSelect={onSelect}
      options={{ previewColor, indicatorColor }}
    />
  );
};
